module.exports = __webpack_public_path__ + "media/此视频借用到产品CS48Q视频.38c92f78.mp4";